<div
  class="values-container"
  *ngIf="!hide"
  [class.mobile]="platform === platformRef.mobile"
  [class.tablet]="platform === platformRef.tablet"
>
  <div class="row1">
    <div>
      <p>
        {{ 'i18n.menuProfitPro.ingredient.quantity' | translate }}
      </p>
      <ion-input
        [class.mobile]="platform === platformRef.mobile"
        [class.tablet]="platform === platformRef.tablet"
        [value]="cardData?.quantity"
        [placeholder]="'#'"
        class="numeric"
        customDecimal
        [maxLeftHandDigits]="4"
        [maxPrecision]="2"
        (ionBlur)="onQuantityInputBlur($event)"
        (click)="stopClickThrough($event)"
        [disabled]="lockEdits"
      ></ion-input>
    </div>
    <div>
      <p>
        {{ 'i18n.menuProfitPro.ingredient.unitOfMeasure' | translate }}
      </p>
      <ion-item
        [class.mobile]="platform === platformRef.mobile"
        [class.tablet]="platform === platformRef.tablet"
        id="ingredient-serv-uom"
        data-cy="ingredient-serv-uom-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        [class.tablet]="platform === platformRef.tablet"
        (click)="onUomDropdownClick($event)"
        [disabled]="lockEdits"
      >
        <ion-label [class.gray]="!cardData?.quantityUom">
          {{
            !!cardData?.quantityUom
              ? (getTranslatedUOM(cardData?.quantityUom) | translate)
              : ('i18n.menuProfitPro.ingredient.uOfM' | translate)
          }}
        </ion-label>
      </ion-item>
    </div>
  </div>
  <div class="row2">
    <div>
      <p>
        {{ 'i18n.menuProfitPro.ingredient.note' | translate }}
      </p>
      <ion-input
        [class.mobile]="platform === platformRef.mobile"
        [class.tablet]="platform === platformRef.tablet"
        [ngModel]="cardData?.note"
        (ngModelChange)="onNoteChange($event)"
        (ionBlur)="onNoteInputBlur($event)"
        [placeholder]="'i18n.menuProfitPro.ingredient.note' | translate"
        class="normal"
        [class.error]="!!noteContainsEmojis"
        [maxlength]="30"
        (click)="stopClickThrough($event)"
        [disabled]="lockEdits"
      ></ion-input>
    </div>
  </div>
  <div class="row3">
    <p class="bold">
      {{ 'i18n.menuProfitPro.ingredient.costAlt' | translate }}
    </p>
    <p [class.gray]="cardData?.cost === 0 || cardData?.cost === null">
      {{ cardData?.cost | currency }}
    </p>
  </div>
</div>
